(function(window, $) {
  // Helper functions
  function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
    var separator = uri.indexOf('?') !== -1 ? '&' : '?';
    if (uri.match(re)) {
      return uri.replace(re, `$1${key}=${value}$2`);
    } else {
      return `${uri + separator + key}=${value}`;
    }
  }
  function getCookie(cname) {
    var name = `${cname}=`;
    var ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }


  // First off, check session storage for trigger flag
  if (sessionStorage.getItem('triggerCheckout')) {
      // Redirect to checkout if flag is found
    sessionStorage.removeItem('triggerCheckout');

    $('html').css('visibility', 'hidden');
    $(function() {
      // Cart page checkout button
      // if ($('form[action="/cart"] input[type="submit"]').length) {
      //   $('form[action="/cart"] input[type="submit"]').trigger('click');
      //   return true;
      // }

      // // Cart drawer checkout button
      // if ($('a[href="/cart"]').length) {
      //   $('a[href="/cart"] input[type="submit"]').trigger('click');
      //   return true;
      // }
      window.location.href = '/checkout';
    });
  } else if (!sessionStorage.getItem('triggerCheckout') && getCookie('cart_currency').toUpperCase() != 'AUD') {
    // Force reload with AUD currency
    newUrl = updateQueryStringParameter(window.location.href, 'currency', 'AUD');
    window.location.replace(newUrl);
  } else {
    $(function() {
      // Initiate geolocation
      Geolizr.addEventListener('geolizr.geoData', function() {
        // console.log('Geoinit')
        var detectedRegion = Geolizr.geoData.countryCode;
        var regions = ['NZ'];
        var regionsTest = ['PH', 'NZ'];

        if (regions.includes(detectedRegion)) {

          $('form[action="/cart"] input[type="submit"], a[href="/checkout"]').on('click', onCheckoutSubmit);
          // $(document).on('click', 'form[action="/cart"] input[type="submit"]', onCheckoutSubmit);

          function onCheckoutSubmit(evt) {
            evt.preventDefault();
            console.log('submit prevented');
            sessionStorage.setItem('triggerCheckout', true);

            newUrl = updateQueryStringParameter('/cart', 'currency', 'NZD');
            window.location.replace(newUrl);
            // console.log(newUrl);
          }
        }
      });
    });
  }
})(window, jQuery);
